import { BlockCard } from "src/modules/worksheet/components/WorksheetEditor/components/Editor";

const renderCardTable = (props: any) => {
    return <BlockCard {...props}>Table (V2) Block</BlockCard>;
};

export default renderCardTable;
